import { Icon, Pill } from '@iwoca/orion';
import IwLink from '@iwRouter/IwLink';

export const SellerDirectoryBanner = () => {
    return (
        <div className="box-border flex w-full flex-wrap items-center justify-start gap-s rounded-s border border-solid border-secondary-90 px-l py-s">
            <Pill variant="green">NEW</Pill>
            <span className="text-m font-bold">
                Our supplier directory is now live!
            </span>
            <IwLink
                to="/iwocapay/directory/"
                className="inline-flex items-center gap-xs !text-primary-40"
            >
                Find iwocaPay suppliers{' '}
                <Icon icon="angleRight" className="fill-primary-40" />
            </IwLink>
        </div>
    );
};
